<app-toast />
<app-consent-banner />

<app-side-menu />
<section>
    <app-nav-bar />
    <div class="router-content">
        <router-outlet />
    </div>
</section>